import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: 'inicio',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'quem-somos',
    loadComponent: () =>
      import('./pages/about-us/about-us.page').then((m) => m.AboutUsPage),
  },
  {
    path: 'seja-fornecedor',
    loadComponent: () =>
      import('./pages/supplier/supplier.page').then((m) => m.SupplierPage),
  },
  {
    path: 'franquias/:id',
    loadComponent: () =>
      import('./pages/franchisee/franchisee.page').then(
        (m) => m.FranchiseePage
      ),
  },
  {
    path: 'faq',
    loadComponent: () => import('./modals/faq/faq.page').then((m) => m.FaqPage),
  },
  {
    path: 'post/:id/:title',
    loadComponent: () =>
      import('./pages/post/post.page').then((m) => m.PostPage),
  },
  {
    path: 'franchisee-form',
    loadComponent: () => import('./modals/franchisee-form/franchisee-form.page').then( m => m.FranchiseeFormPage)
  },
  {
    path: 'blog',
    loadComponent: () =>
      import('./pages/blog/blog.page').then((m) => m.BlogPage),
  },
  {
    path: 'blog-trigo',
    loadComponent: () =>
      import('./pages/blog/blog.page').then((m) => m.BlogPage),
  },
  {
    path: 'seja-franqueado',
    loadComponent: () =>
      import('./pages/franchisee-register/franchisee-register.page').then(
        (m) => m.FranchiseeRegisterPage
      ),
  },
  {
    path: 'jogo-interativo',
    loadComponent: () => import('./pages/game/game.page').then( m => m.GamePage)
  },
  {
    path: 'postagem/:id/:title',
    loadComponent: () => import('./pages/postagem/postagem.page').then( m => m.PostagemPage)
  },
  {
    path: '**',
    redirectTo: 'inicio'
  },


];
